import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

/**
 * Health Spending Chart
 * Shows health spending as % of GDP - baseline vs SAFECARE
 */
export default function HealthSpendingChart({ scenario, baseline, showEvents }) {
    if (!scenario || !baseline) return null;

    // Transform data for chart
    // We assume scenario and baseline are aligned by index since they come from the same loop structure
    const chartData = scenario.map((year, i) => {
        const baselineYear = baseline[i];
        return {
            year: year.year,
            'CMS Baseline': (year.baselineHealthShareGDP * 100).toFixed(1),
            'Safecare (No Events)': (baselineYear.safecareHealthShareGDP * 100).toFixed(1),
            'Safecare (With Events)': (year.safecareHealthShareGDP * 100).toFixed(1)
        };
    }).filter(d => d.year >= 2026);

    return (
        <div className="chart-container">
            <h3>Health Spending as % of GDP</h3>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--bg-tertiary)" />
                    <XAxis
                        dataKey="year"
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                    />
                    <YAxis
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                        label={{ value: '% of GDP', angle: -90, position: 'insideLeft', fill: 'var(--text-muted)', fontSize: '11px' }}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: 'rgba(255, 255, 255, 0.96)',
                            border: '1px solid var(--glass-border)',
                            borderRadius: '12px',
                            color: 'var(--text-primary)',
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                            fontSize: '13px'
                        }}
                        formatter={(value) => `${value}%`}
                    />
                    <Legend
                        wrapperStyle={{ color: 'var(--text-primary)', fontSize: '12px', fontWeight: 600, paddingTop: '10px' }}
                    />
                    <Line
                        type="monotone"
                        dataKey="CMS Baseline"
                        stroke="#ff6b6b"
                        strokeWidth={2}
                        dot={{ fill: '#ff6b6b', r: 3 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="Safecare (No Events)"
                        stroke="#4ecdc4"
                        strokeWidth={2}
                        dot={{ fill: '#4ecdc4', r: 3 }}
                    />
                    {showEvents && (
                        <Line
                            type="monotone"
                            dataKey="Safecare (With Events)"
                            stroke="#ffe66d"
                            strokeWidth={2}
                            dot={{ fill: '#ffe66d', r: 3 }}
                        />
                    )}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
